export default __webpack_public_path__ + "static/media/computer-screen-with-solutions.ca2669a3.svg";